/**
 * Frontend mirror of the backend `duration_days()` formula (server.py).
 * Keep the two in sync — the backend copy is the source of truth and is unit
 * tested in backend/tests/test_cluster3_labor_math.py.
 *
 *   duration_days = ceil( (budgeted_hours × factor × (1 − percent_complete))
 *                         ÷ (crew_size × hours_per_day) )
 */
export function durationDays(budgetedHours, crewSize, hoursPerDay, factor = 0.8, percentComplete = 0) {
  const hours = Number(budgetedHours) || 0;
  const crew = Number(crewSize) || 0;
  const hpd = Number(hoursPerDay) || 0;
  const f = factor == null ? 0.8 : Number(factor);
  const pc = Math.min(Math.max(Number(percentComplete) || 0, 0), 1);
  if (hours <= 0 || crew <= 0 || hpd <= 0) return 0;
  return Math.ceil((hours * f * (1 - pc)) / (crew * hpd));
}

export const remainingDurationDays = (hours, crew, hpd, factor, percentComplete) =>
  durationDays(hours, crew, hpd, factor, percentComplete);

// Whichever completion date lands first, plus which one it is.
export function soonerCompletion(absDate, gcDate) {
  const a = (absDate || "").slice(0, 10);
  const g = (gcDate || "").slice(0, 10);
  if (a && g) return a <= g ? { date: a, source: "ABS" } : { date: g, source: "GC" };
  if (a) return { date: a, source: "ABS" };
  if (g) return { date: g, source: "GC" };
  return { date: "", source: "" };
}

export const MATERIAL_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "ordered", label: "Ordered" },
  { value: "on_hand", label: "On-hand" },
];
